module.exports = __webpack_public_path__ + "static/media/a4.ad7dc10.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sijie/a4.mp3
// module id = AlYy
// module chunks = 0